import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["share", "copy", "link"]

  connect() {
    if (navigator.share && this.hasShareTarget) {
      this.shareTarget.style.display = ""
    } else {
      this.copyTarget.style.display = ""
    }
  }

  share(e) {
    e.preventDefault()
    navigator.share({
      title: "Spark Golf",
      url: this.data.get("url")
    })
    gtagEvent("share", { event_category: "league", event_label: this.data.get("name") })
  }

  copy(e) {
    e.preventDefault()
    if (this.hasLinkTarget) {
      this.linkTarget.select()
      document.execCommand("copy")
      gtagEvent("copy", { event_category: "league", event_label: this.data.get("name") })
    }
  }
}
